import React, { Component } from "react";
import { connect } from "react-redux";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/messaging";
import userAction from "../../actions/userAction";
import notificationsAction from "../../actions/notificationsAction";
import AppContainer from "../../components/AppContainer";
import Header from "../../components/Header";
import PageTitle from "../../components/PageTitle";
import SettingsContainer from "./SettingsContainer";
import NotificationPermissionButton from "./NotificationPermissionButton";
import CloseButton from "./CloseButton";
import NotificationsSpotForm from "./NotificationsSpotForm";
import spots from "../../config/spots";

class Settings extends Component {
  // Saves the messaging device token to the datastore.
  askForPermissioToReceiveNotifications() {
    const { notificationsAction } = this.props;

    const spotData = {
      initial: spots.reduce((current, item) => {
        current[item] = false;
        return current;
      }, {}),
    };

    for (var i = 0; i < spots.length; i++) {
      const spot = spots[i];
      spotData.initial[`${spot}Size`] = 1;
      spotData.initial[`${spot}Period`] = 10;
    }

    console.log("Requesting notifications permission...");
    try {
      firebase
        .messaging()
        .getToken()
        .then(function (currentToken) {
          if (currentToken) {
            console.log("Got FCM device token:", currentToken);
            firebase
              .firestore()
              .collection("uid")
              .doc(firebase.auth().currentUser.uid)
              .set({ token: currentToken, ...spotData.initial });
            notificationsAction(Notification.permission);
          }
        })
        .catch(function (error) {
          console.error("Unable to get messaging token.", error);
        });
    } catch (error) {
      console.error(error);
    }
  }

  componentDidMount() {
    const { userAction, notificationsAction } = this.props;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in.
        const isAnonymous = user.isAnonymous;
        const uid = user.uid;
        console.log(`isAnonymous: ${isAnonymous}\nuid: ${uid}`);
        userAction(uid);
      } else {
        // User is signed out.
        // ...
      }
      // ...
    });
    if ("Notification" in window) {
      notificationsAction(Notification.permission);
    }
  }

  notificationAskOnClick = () => {
    this.askForPermissioToReceiveNotifications();
  };

  render() {
    const { notificationsPermission, userId } = this.props;
    console.log(this.props);

    return (
      <AppContainer>
        <CloseButton onClick={() => this.props.history.goBack()} />
        <Header>
          <PageTitle>Settings</PageTitle>
        </Header>
        <SettingsContainer>
          {notificationsPermission === "default" && (
            <NotificationPermissionButton
              onClick={this.notificationAskOnClick}
            />
          )}
          {notificationsPermission === "granted" && userId && (
            <NotificationsSpotForm userId={userId} />
          )}
        </SettingsContainer>
      </AppContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});
const mapDispatchToProps = (dispatch) => ({
  notificationsAction: (payload) => dispatch(notificationsAction(payload)),
  userAction: (payload) => dispatch(userAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
